<header class="bf-header hidden md:block">
  <div class="mx-auto flex min-h-30 max-w-7xl items-center justify-between px-6 md:justify-center lg:justify-between">

    <div class="bulls-barber-container hidden lg:block">
      <a routerLink="/">
        <img
          src="/images/bonefade-source/bulls-white-logo.png"
          alt="Bonefade Barbers"
        />
      </a>
    </div>

    <nav class="relative hidden flex-col items-start gap-3 md:flex">
      <div class="flex items-center gap-8">
        <a
          routerLink="/"
          class="relative font-label py-1 text-sm font-medium uppercase transition after:absolute after:bottom-0 after:left-1/2 after:h-[calc(var(--spacing)*0.3)] after:w-[30px] after:-translate-x-1/2 after:bg-white after:opacity-0 after:transition-opacity after:content-[''] hover:after:opacity-100"
        >
          Kezdőlap
        </a>

        <a
          href="/"
          appScrollToSection="bf-summary"
          class="relative font-label py-1 text-sm font-medium uppercase transition after:absolute after:bottom-0 after:left-1/2 after:h-[calc(var(--spacing)*0.3)] after:w-[30px] after:-translate-x-1/2 after:bg-white after:opacity-0 after:transition-opacity after:content-[''] hover:after:opacity-100"
        >
          Rólunk
        </a>

        <a
          href="/arak"
          appScrollToSection="price-list"
          [scrollBelowBreakpoint]="1024"
          routeTarget="/arak"
          class="relative font-label py-1 text-sm font-medium uppercase transition after:absolute after:bottom-0 after:left-1/2 after:h-[calc(var(--spacing)*0.3)] after:w-[30px] after:-translate-x-1/2 after:bg-white after:opacity-0 after:transition-opacity after:content-[''] hover:after:opacity-100"
        >
          Árak
        </a>

        <a
          href="/galeria"
          appScrollToSection="gallery-grid"
          [scrollBelowBreakpoint]="1024"
          routeTarget="/galeria"
          class="relative font-label py-1 text-sm font-medium uppercase transition after:absolute after:bottom-0 after:left-1/2 after:h-[calc(var(--spacing)*0.3)] after:w-[30px] after:-translate-x-1/2 after:bg-white after:opacity-0 after:transition-opacity after:content-[''] hover:after:opacity-100"
        >
          Galéria
        </a>

        <a
          href="/#kapcsolat"
          appScrollToSection="kapcsolat"
          [global]="true"
          class="relative font-label py-1 text-sm font-medium uppercase transition after:absolute after:bottom-0 after:left-1/2 after:h-[calc(var(--spacing)*0.3)] after:w-[30px] after:-translate-x-1/2 after:bg-white after:opacity-0 after:transition-opacity after:content-[''] hover:after:opacity-100"
        >
          Kapcsolat
        </a>

        <button
          type="button"
          class="bf-button"
          (click)="toast.show('Coming soon')"
        >
          Időpontfoglalás
        </button>
      </div>

      <app-social-links class="hidden lg:absolute lg:top-[92px] lg:left-0 lg:block"></app-social-links>
    </nav>

    <button
      type="button"
      class="rounded-lg border border-white/10 p-3 md:hidden"
      aria-label="Menü megnyitása"
    >
      ☰
    </button>

  </div>
</header>
